(() => {
  const init = (section) => {
    if (!section || section.dataset.ggInit === "true") return;
    section.dataset.ggInit = "true";

    const grid = section.querySelector("[data-gg-grid]");
    const searchInput = section.querySelector("[data-gg-search]");
    const filters = section.querySelectorAll("[data-gg-filter]");
    const resetBtn = section.querySelector("[data-gg-reset]");
    const countNode = section.querySelector("[data-gg-count]");
    const emptyNode = section.querySelector("[data-gg-empty]");

    if (!grid) return;

    const cards = [...grid.querySelectorAll(".gg-card")];

    /**
     * Convert data attributes into searchable token arrays.
     *
     * Supports:
     * data-color="white grey"
     * data-color="white,grey"
     * data-meaning="wisdom love joy transformation"
     * data-meaning="wisdom,love,joy,transformation"
     */
    const toTokens = (value) => {
      return String(value || "")
        .toLowerCase()
        .replace(/,/g, " ")
        .split(/\s+/)
        .map(item => item.trim())
        .filter(Boolean);
    };

    const apply = () => {
      const q = searchInput
        ? searchInput.value.trim().toLowerCase()
        : "";

      const active = {};

      filters.forEach(filter => {
        const key = filter.dataset.ggFilter;
        active[key] = String(filter.value || "").toLowerCase();
      });

      let visible = 0;

      cards.forEach(card => {
        const name = String(card.dataset.name || "").toLowerCase();

        const colors = toTokens(card.dataset.color);
        const months = toTokens(card.dataset.month);
        const meanings = toTokens(card.dataset.meaning);
        const hardnesses = toTokens(card.dataset.hardness);

        const matchesSearch =
          !q || name.includes(q);

        const matchesColor =
          !active.color || colors.includes(active.color);

        const matchesMonth =
          !active.month || months.includes(active.month);

        const matchesMeaning =
          !active.meaning || meanings.includes(active.meaning);

        const matchesHardness =
          !active.hardness || hardnesses.includes(active.hardness);

        const ok =
          matchesSearch &&
          matchesColor &&
          matchesMonth &&
          matchesMeaning &&
          matchesHardness;

        card.hidden = !ok;

        if (ok) visible++;
      });

      if (countNode) {
        countNode.textContent = `${visible} gemstone${visible === 1 ? "" : "s"} found`;
      }

      if (emptyNode) {
        emptyNode.hidden = visible !== 0;
      }
    };

    const debounce = (fn, delay = 100) => {
      let timer;

      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => fn(...args), delay);
      };
    };

    if (searchInput) {
      searchInput.addEventListener("input", debounce(apply));
    }

    filters.forEach(filter => {
      filter.addEventListener("change", apply);
    });

    if (resetBtn) {
      resetBtn.addEventListener("click", () => {
        if (searchInput) {
          searchInput.value = "";
        }

        filters.forEach(filter => {
          filter.value = "";
        });

        apply();
      });
    }

    apply();
  };

  const initAll = () => {
    document.querySelectorAll("[data-gemstone-guide]").forEach(init);
  };

  document.addEventListener("DOMContentLoaded", initAll);

  document.addEventListener("shopify:section:load", (event) => {
    const section =
      event.target.querySelector("[data-gemstone-guide]") || event.target;

    init(section);
  });
})();